import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import "../Inputs/InputRe.css";
import "./Dropdown.scss";
import useCreateUrl from '../../../Hooks/useCreateUrl';
import ShimmerInput from "../ShimmerInput/ShimmerInput";

const Dropdown = (props) => {


    const [selectedOption, setSelectedOption] = useState("");
    const [reactSelectOptions, setReactSelectOptions] = useState("");
    const { ariaInvalid, 
            ariaDescribedby,
            optionValue, 
            optionName, 
            optionId, 
            label, 
            preSelectedValue, 
            options, 
            editMode, 
            selectedOptionLabel, 
            selectedOptionId,
            setFieldsLoading, 
            fieldLoading, 
            handleOnBlur, 
            handleOnChange,
            setMatchNotFound } = props;

    const inputWidth = () => {

        switch (props.inputSize) {
            case 'full-width':
                return "full-width";
            case 'large':
                return "large";
            case 'medium':
                return "medium";
            case 'small':
                return "small";
            default:
                return "large";
        }
    };

    const handleChangeState = (option) => {

        setSelectedOption(option);

        if (handleOnChange) {
            handleOnChange({
                target: {
                    value: option?.value || '',
                    name: option?.label || '',
                    id: option?.id || '',
                }
            });
        }
        
        setFieldsLoading(false);
    };
    
    
    const handleBlurState=()=>{
     
        if (handleOnBlur && !fieldLoading) {
            handleOnBlur({
                target: {
                    value: selectedOption?.value || "",
                    name: selectedOption?.label || "",
                    id: selectedOption?.id || "",
                }
            });
        }
     }

    useEffect(()=>{
      
        handleBlurState();

    }, [selectedOption])
  
    useEffect(() => {
        if (!options) return;

        const list = options.map(option => ({
            value: option[optionValue],
            label: option[optionName],
            id: option[optionId]
        }));

        setReactSelectOptions(list);

        const matched = list.find(
            //matching from loqate or in edit delivery details state
            option => (option?.value === preSelectedValue || option?.id === selectedOptionId)
        );
        console.log(matched);

        if (matched) {
            handleChangeState(matched);
        }else{

            if(preSelectedValue){

               //only when match not found from loqate 
               setMatchNotFound(true);
            }
            setFieldsLoading(false);
        }

    }, [options, editMode, preSelectedValue]);

    const savedOption = selectedOptionId ? { id: selectedOptionId, label: selectedOptionLabel } : null;   //edit delivery details mode

    const selected = selectedOption || savedOption || null;   

    const customStyles = {
        control: (base) => ({
            ...base,
            border: '1px solid #fafafa00',
            backgroundColor: '#fafafa00',
            height: '48px',
            padding: '0 9px',
            fontSize: '16px',
            fontWeight: 'normal',
            boxShadow: 'none',
            borderRadius: 0,
            transition: 'box-shadow 0.12s ease-in',

            '&:hover': {
                border: '1px solid #fafafa00',
                boxShadow: 'none',
            },
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            paddingTop: 0,
            paddingBottom: 2,
        }),
        valueContainer: (base) => ({
            ...base,
            padding: 0,
        }),
        menu: (base) => ({
            ...base,
            position: 'absolute',
            top: '41px',
            width: '100%',
            backgroundColor: 'white',
            boxShadow: '0 0 0 1px #1175D2',
            borderLeft: '2px solid #1175D2',
            borderRight: '2px solid #1175D2',
            borderBottom: '2px solid #1175D2',
            borderRadius: 0,
            zIndex: 10,
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#000000',
            '&:hover': {
                color: '#000000',
            },
            '& svg': {
                width: '15px',   // change this to desired width
                height: '15px',  // change this to desired height
            },
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
            color: 'black',
            fontSize: '16px',
            padding: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#00000', // Change this to your desired color
           
        }),
    };

    const labelField = () => {
        return <div class="label-wrapper">
                  <div class="label-text">
                     <label className="label" htmlFor={props.id}> {props.label} </label>
                      {props.description ? <p className="label-description">{props.description}</p> : ""}
                      {(props.specs === "search_input") && <p className="meta">Type first letters to find..</p>}
                  </div>
              </div> }


    return (<> 
         
         {fieldLoading ? <div className="dropdown-wrapper">
                            <ShimmerInput />
                          </div>
             :
           <>
            {(!label && !props?.description && !props?.optionalField && !props?.helpField) ? !labelField() : labelField()}

            <div className="dropdown-wrapper">
                <div className={`div-wrapper ${inputWidth()} ${props.invalidClass ? props.invalidClass : props.disabled === "true" ? "" : (selected?.label?.length > 0) ? "filled" : ""}`}>
        
                    <Select
                        classNamePrefix="div-wrapper"
                        id={props.id+"dropdown"}
                        options={reactSelectOptions}
                        onChange={handleChangeState}
                        onBlur={handleBlurState}
                        value={selected}
                        placeholder={props.selectItemInstructions}
                        styles={customStyles}
                        aria-invalid={ariaInvalid}
                        aria-describedby={ariaInvalid ? `${ariaDescribedby}` : undefined}
                        isClearable={false}
                        components={{
                            IndicatorSeparator: () => null
                        }} />
                 </div>
             </div>
          </>}
    </>
    );
};

export default Dropdown;
